var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"confirmation"},[_c('div',{staticClass:"icon text-center"},[_c('font-awesome-icon',{attrs:{"icon":"fa-solid fa-check"}})],1),_c('h2',{staticClass:"text-center"},[_vm._v("Vielen Dank für deine Buchung")]),_c('p',{staticClass:"text-center"},[_vm._v("Wir senden Dir alle Details per E-Mail.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }